import { ViewModel } from './model';
import checkHtml from './template.html';
import './style.less';

ko.components.register('input-checkbox', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('input-checkbox');

      return new ViewModel(params, element);
    }
  },
  template: checkHtml
});
